import {Typography} from '@mui/material';
import React from 'react';

import {SearchBar} from '../SearchBar';
import {StyledStack} from './styles';
import {SubheaderWithSearchProps} from './types';

export function SubheaderWithSearch({placeholder, title, hasSearch}: SubheaderWithSearchProps) {
	return (
		<StyledStack>
			{title ? (
				<Typography variant="h6" color="white">
					{title}
				</Typography>
			) : null}
			{hasSearch ? <SearchBar placeholder={placeholder} /> : null}
		</StyledStack>
	);
}
